import React, { lazy } from 'react';
import { BookOpenCheckIcon, CheckIcon, CookingPotIcon, RefrigeratorIcon, ReceiptEuroIcon } from 'lucide-react';
const BONUS_COLLECTION_URL = 'https://cdn.magicpatterns.com/uploads/voEkb55wi5Ms76LgLfAVow/B3E630CD-68D1-44F4-B3C5-9AD0CB191804.jpg';
const inclusions = ['+1000 recetas saludables para congelar.', 'Método Meal Prep paso a paso.', 'Técnicas para conservar sabor, textura y calidad.', 'Sistema de planificación semanal.', 'Consejos para ahorrar hasta un 45% en tus compras.', 'Guía para recalentar correctamente tus comidas.', 'Estrategias para conservar alimentos durante más tiempo.'];
const previewCards = [{
  icon: CookingPotIcon,
  label: 'Recetas que congelan bien',
  color: 'bg-[#a92d3d]'
}, {
  icon: RefrigeratorIcon,
  label: 'Conservación inteligente',
  color: 'bg-[#397352]'
}, {
  icon: ReceiptEuroIcon,
  label: 'Compra sin desperdicio',
  color: 'bg-[#c33d4c]'
}];
export function ProductDetails() {
  return <>
      <section id="contenido" className="bg-[#e8f0df] px-5 py-16 sm:px-8 sm:py-24" data-id="element-153" data-mp="187sqapa61oui">
        <div className="mx-auto max-w-7xl" data-id="element-154" data-mp="146ql7rtkiikm">
          <div className="grid items-center gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20" data-id="element-155" data-mp="1hyx2xicdcxm6">
            <figure className="relative overflow-hidden rounded-[2rem] border-8 border-[#fffaf0] bg-[#d9e5cc] shadow-xl" data-id="element-156" data-mp="1i0rei61r3ddl">
              <img src={BONUS_COLLECTION_URL} alt="Ebook Meal Prep Club acompañado de los cinco bonos digitales incluidos" width={901} height={973} loading="lazy" decoding="async" className="h-72 w-full object-cover object-center sm:h-[29rem]" data-id="element-157" data-mp="p9punrn44tnq" />
              <figcaption className="absolute bottom-4 left-4 rounded-full bg-[#143827] px-4 py-2 text-xs font-bold uppercase tracking-[0.12em] text-[#fffaf0] shadow-lg" data-id="element-158" data-mp="uboyf2mrlsl7">
                Ebook + 5 bonos incluidos
              </figcaption>
            </figure>
            <div data-id="element-159" data-mp="2dofc14ew6x36">
              <p className="text-sm font-bold uppercase tracking-[0.16em] text-[#397352]" data-id="element-160" data-mp="2doxh8qjj8ln8">
                Dentro de Meal Prep Club
              </p>
              <h2 className="font-display mt-4 text-4xl font-black leading-[0.98] tracking-[-0.045em] text-[#143827] sm:text-5xl" data-id="element-161" data-mp="2mpdjjwojhmqi">
                📖 Todo lo que necesitas para empezar con confianza.
              </h2>
              <ul className="mt-7 grid gap-3 sm:grid-cols-2" role="list" data-id="element-162" data-mp="1u296r5j7g446">
                {inclusions.map(inclusion => <li key={inclusion} className="flex gap-2.5 text-sm leading-relaxed text-[#405646]" data-id="element-163" data-mp="1z0kijlt28op1">
                    <CheckIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-[#a92d3d]" data-id="element-164" data-mp="28qdqmctzuloj" />
                    {inclusion}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-[#f4ecdb] px-5 py-16 sm:px-8 sm:py-24" data-id="element-165" data-mp="18oz9xep764u2">
        <div className="mx-auto max-w-7xl" data-id="element-166" data-mp="13qo0h52tdwcd">
          <div data-id="element-167" data-mp="13ryzysp88hxo">
            <div className="flex flex-col justify-between gap-4 sm:flex-row sm:items-end" data-id="element-168" data-mp="13pctyxhziahk">
              <div data-id="element-169" data-mp="yu78u0weozuj">
                <p className="text-sm font-bold uppercase tracking-[0.16em] text-[#397352]" data-id="element-170" data-mp="tt1fc0ux98jy">
                  Un vistazo al interior
                </p>
                <h2 className="font-display mt-3 text-3xl font-black tracking-[-0.04em] text-[#143827] sm:text-4xl" data-id="element-171" data-mp="pszc3n9jg72k">
                  🍽️ Un plan claro, de la compra al plato.
                </h2>
              </div>
              <BookOpenCheckIcon aria-hidden="true" className="h-10 w-10 text-[#a92d3d]" data-id="element-172" data-mp="g1wfaxnn6e93" />
            </div>
            <div className="mt-8 grid gap-4 md:grid-cols-3" data-id="element-173" data-mp="63oyqfx9ly7m">
              {previewCards.map(({
              icon: Icon,
              label,
              color
            }, index) => <div key={label} className={`${color} relative min-h-52 overflow-hidden rounded-2xl p-6 text-white shadow-md`} data-id="element-174" data-mp="22n6ij1rmmf5" data-mpi={index}>
                  <span className="text-xs font-bold uppercase tracking-[0.13em] text-white/75" data-id="element-175" data-mp="vq9khq0wxzol">
                    Capítulo {index + 1}
                  </span>
                  <Icon aria-hidden="true" className="absolute right-5 top-5 h-8 w-8 text-white/85" data-id="element-176" data-mp="m19gttbgug42" />
                  <p className="font-display absolute bottom-6 left-6 right-6 text-2xl font-black leading-tight tracking-[-0.03em]" data-id="element-177" data-mp="8430e5e7sti0">
                    {label}
                  </p>
                </div>)}
            </div>
          </div>
        </div>
      </section>
    </>;
}